module.exports = __webpack_public_path__ + "img/instagram.999ef8b.svg";